import { render, staticRenderFns } from "./UserPasswordResetDialog.vue?vue&type=template&id=b65229c8&"
import script from "./UserPasswordResetDialog.vue?vue&type=script&lang=js&"
export * from "./UserPasswordResetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports